import BaseBadge from "./BaseBadge.vue";

export * from "./BaseBadge.vue";
export default BaseBadge;
